import { render, staticRenderFns } from "./xskSku2.vue?vue&type=template&id=b0af7afa&scoped=true"
import script from "./xskSku2.vue?vue&type=script&lang=js"
export * from "./xskSku2.vue?vue&type=script&lang=js"
import style0 from "./xskSku2.vue?vue&type=style&index=0&id=b0af7afa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0af7afa",
  null
  
)

export default component.exports